import {Unlock, LOCK_OPENING_TYPES, LOCK_VENDORS, hasMultipleRooms} from '@chekin/core';

export {hasMultipleRooms} from '@chekin/core';

const isKeylessLock = (unlock: Unlock) =>
  unlock.lock?.vendor === LOCK_VENDORS.keylessDubai;

const isDoorLock = (unlock: Unlock) =>
  !isKeylessLock(unlock) && !hasMultipleRooms(unlock);

const canOpenRemotely = (unlock: Unlock) =>
  Boolean(unlock.token) && unlock.lock?.opening_type !== LOCK_OPENING_TYPES.CODE;

export {isKeylessLock, isDoorLock, canOpenRemotely};
